<template>
  <div id="app">
    <first-Component page="home"></first-Component>
<!--    <el-dialog  :visible.sync="outerVisible">-->
<!--              <div class="diaCon">-->
<!--                <p>{{$t('dialog')[0]}}</p>-->
<!--                <p>{{$t('dialog')[1]}}<br>-->
<!--                  {{$t('dialog')[2]}}<br>-->
<!--                 <span style="font-weight: bold"> {{$t('dialog')[3]}}<br></span>-->
<!--                  {{$t('dialog')[4]}}<br>-->
<!--                  {{$t('dialog')[5]}}</p>-->
<!--              </div>-->
<!--    </el-dialog>-->
    <div id="scroller-wrapper" data-scrollbar >
      <home-Component></home-Component>
    </div>

  </div>
</template>

<script>
  import  {WOW} from 'wowjs'
  import Scrollbar from 'smooth-scrollbar';
  import firstComponent from '@/components/first.vue'
  import homeComponent from '@/views/Home.vue'
  export default {
    name: 'home',
    data(){
      return{
        outerVisible: false,
        noShow:{},
        wow:'',
        scrollbar:''
      }
    },
    // watch:{
    //   '$route':'init'
    // },
    components:{firstComponent,homeComponent},
    mounted() {
      this.wow=new WOW();
      this.init()
      setTimeout(()=>{
        this.outerVisible = true
      },1000)
      // this.$router.beforeEach((to, from, next) => {
      //   Scrollbar.destroyAll()
      //   next()
      // })
    },
    methods:{
      init(){
        this.$nextTick(()=>{
          this.scrollbar = Scrollbar.init(document.getElementById('scroller-wrapper'));
          this.wow.init()
          this.noShow={display:'block'}
          let scrollbar=Scrollbar.get(document.getElementById('scroller-wrapper'))
          scrollbar.scrollTo(0,0)
          window.pageYOffset=this.scrollbar.scrollTop
          this.scrollbar.addListener(() => {
            this.wow.scrollHandler()
            window.pageYOffset=this.scrollbar.scrollTop
            if(window.pageYOffset>0){
              this.noShow={display:'none'}
            }
          });
        })
      }
    }
  }
</script>
<style>
  body{
    margin: 0;
    padding: 0;
  }
  ul,li,p,a{
    margin: 0;
    padding: 0;
    text-decoration: none;
    color:black;
  }
  .diaCon p:nth-child(1){
    font-weight: bold;
    font-size: 18px;
    padding-bottom: 20px;
  }
  .diaCon p:nth-child(2){
    line-height: 40px;
  }
  .el-input{
    width:45% !important;
    margin-left:5%;
    margin-top: 30px;
  }
  .el-textarea{
    width:95%;
    margin-left: 5%;
    margin-top: 30px;
  }
  input:focus {
    border-color: #DCDFE6 !important;
    outline: 0;
  }
  textarea:focus{
    border-color: #DCDFE6 !important;
    outline: 0;
    resize: none !important;
  }
  .donghua{
    height:100vh;
    width:100%;
    position: absolute;
    top:0;
    left:0;
    z-index: 999;
    color:white;
    background-color: black;
    animation-duration: 600ms;
    animation-delay: 100ms;
  }
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width:100%;
  overflow: hidden;
}
  #scroller-wrapper{
    position: relative;
    height: 100vh;
    overflow: hidden;
    /* z-index: 101; */
  }
  .scrollbar-thumb{
    width:3px !important;
    background-color: #005FAC!important;
  }
  .scrollbar-track-y{
    width:3px !important;
  }
  @media screen and (max-width: 999px){
    .el-dialog{
      width:80% !important;
    }
    .diaCon p:nth-child(2){
      line-height: 30px;
      font-size: 13px;
    }
  }
</style>
